export const DRAWER_OPEN_WIDTH = 256
export const DRAWER_CLOSED_WIDTH = 76
export const DRAWER_WIDTH_DIFFERENCE = DRAWER_OPEN_WIDTH - DRAWER_CLOSED_WIDTH

const styles = (theme) => ({
  drawer: {
    width: DRAWER_OPEN_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    position: 'relative',
    height: '100%',
    border: 0,
    backgroundColor: theme.palette.layout.main,
  },
  paper: {
    border: 0,
    backgroundColor: theme.palette.layout.main,
    top: 'calc(var(--dpoday-banner-height, 0px) + 56px)',
    height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 56px))',
    transition: 'top 0.3s ease, height 0.3s ease',
    [theme.breakpoints.up('sm')]: {
      top: 'calc(var(--dpoday-banner-height, 0px) + 64px)',
      height: 'calc(100% - (var(--dpoday-banner-height, 0px) + 64px))',
    },
  },
  drawerOpen: {
    width: DRAWER_OPEN_WIDTH,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
})

export default styles
